import { Action } from '@ngrx/store';
import { GetAlertsPayload } from '@eview/core/models/get-alerts';

export enum EGetAlertsActions {
    GetAlertsPost = '[Posts] Get alerts',
    GetAlertsSuccess = '[Posts] Get alerts success',
    GetAlertsFailure = '[Posts] Get alerts failure'
}

export class GetAlertsPost implements Action {
    readonly type = EGetAlertsActions.GetAlertsPost;
    constructor(public payload: GetAlertsPayload) { }
}

export class GetAlertsSuccess implements Action {
    readonly type = EGetAlertsActions.GetAlertsSuccess;
}

export class GetAlertsFailure implements Action {
    readonly type = EGetAlertsActions.GetAlertsFailure;
}

export type GetAlertsActions = GetAlertsPost | GetAlertsSuccess | GetAlertsFailure;
